var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _g58, _g59, _path, _path2, _path3, _g60, _g61, _g62, _g63, _g64, _g65, _path4, _path5, _path6, _path7, _path8, _g66, _path9, _path10, _path11, _path12, _path13, _g67, _path14, _path15, _g68, _g69, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCookiePhase2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 1015.01 1233",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1-cookie-p2, .cls-2-cookie-p2, .cls-3-cookie-p2, .cls-4-cookie-p2 {\n        stroke: #1071e5;\n      }\n\n      .cls-1-cookie-p2, .cls-5-cookie-p2 {\n        fill: #fff;\n      }\n\n      .cls-6-cookie-p2, .cls-5-cookie-p2, .cls-7-cookie-p2, .cls-8-cookie-p2, .cls-9, .cls-10-cookie-p2 {\n        stroke-width: 0px;\n      }\n\n      .cls-11-cookie-p2 {\n        fill: url(#cookie-linear-gradient-p2);\n      }\n\n      .cls-11-cookie-p2, .cls-12-cookie-p2, .cls-13-cookie-p2, .cls-14-cookie-p2, .cls-15-cookie-p2 {\n        stroke: #2b8eff;\n      }\n\n      .cls-12-cookie-p2, .cls-3-cookie-p2 {\n        stroke-width: .05px;\n      }\n\n      .cls-12-cookie-p2, .cls-13-cookie-p2, .cls-7-cookie-p2 {\n        fill: #2b8eff;\n      }\n\n      .cls-2-cookie-p2, .cls-3-cookie-p2 {\n        fill: #1071e5;\n      }\n\n      .cls-15-cookie-p2 {\n        fill: transparent;\n      }\n\n      .cls-8-cookie-p2 {\n        fill: #3a414a;\n      }\n\n      .cls-9 {\n        fill: #e81313;\n      }\n\n      .cls-14-cookie-p2, .cls-4-cookie-p2 {\n        fill: none;\n      }\n\n      .cls-10-cookie-p2 {\n        fill: #008a0e;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cookie-linear-gradient-p2",
    x1: 21068.65,
    y1: 2809.6,
    x2: 21068.65,
    y2: 2603.98,
    gradientTransform: "translate(-20225.27 3450.1) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edf5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#6db1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1071e5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "rect8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1-cookie-p2",
    d: "M.5,750.5c0-3.31,2.69-6,6-6h330.26c3.31,0,6,2.69,6,6v100c0,3.31-2.69,6-6,6H6.5c-3.31,0-6-2.69-6-6v-100Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aa",
    className: "cls-6-cookie-p2",
    d: "M35.22,774.87v14.94h-2.31v-14.94h-5.77v-1.9h13.85v1.9h-5.77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ab",
    className: "cls-6-cookie-p2",
    d: "M48.32,778.74c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ac",
    className: "cls-6-cookie-p2",
    d: "M58.24,787.36c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM51.92,786.21c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad",
    className: "cls-6-cookie-p2",
    d: "M70.19,776.63c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ae",
    className: "cls-6-cookie-p2",
    d: "M84.99,780.1c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "af",
    className: "cls-6-cookie-p2",
    d: "M89.67,789.81v-17.72h2.17v17.72h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ac-2",
    "data-name": "ac",
    className: "cls-6-cookie-p2",
    d: "M102.98,787.36c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM96.67,786.21c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ag",
    className: "cls-6-cookie-p2",
    d: "M110.99,786.61c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah",
    className: "cls-6-cookie-p2",
    d: "M115.41,774.12v-2.04h2.17v2.04h-2.17ZM115.41,789.81v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ai",
    className: "cls-6-cookie-p2",
    d: "M125.93,776.63c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM125.87,788.45c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad-2",
    "data-name": "ad",
    className: "cls-6-cookie-p2",
    d: "M140.67,776.63c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aj",
    className: "cls-6-cookie-p2",
    d: "M160.9,776.63c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31ZM160.36,788.45c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ac-3",
    "data-name": "ac",
    className: "cls-6-cookie-p2",
    d: "M176.25,787.36c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM169.93,786.21c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ae-2",
    "data-name": "ae",
    className: "cls-6-cookie-p2",
    d: "M189.42,780.1c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ae-3",
    "data-name": "ae",
    className: "cls-6-cookie-p2",
    d: "M201.64,780.1c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ak",
    className: "cls-6-cookie-p2",
    d: "M211.49,776.63c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM215.02,782.13c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "al",
    className: "cls-6-cookie-p2",
    d: "M224.05,776.63c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM224.66,778.26c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    id: "am",
    className: "cls-6-cookie-p2",
    d: "M246.46,776.63c3.6,0,4.69,2.65,4.75,6.65,0,4.48-1.56,6.79-4.75,6.79-2.1-.07-3.33-.75-4.01-2.31l-.14,2.04h-2.1l.07-17.72h2.17v6.86c.68-1.56,1.9-2.31,4.01-2.31ZM245.91,788.45c2.72,0,3.06-2.31,3.06-5.09s-.34-5.09-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ac-4",
    "data-name": "ac",
    className: "cls-6-cookie-p2",
    d: "M261.8,787.36c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM255.49,786.21c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "an",
    className: "cls-6-cookie-p2",
    d: "M272.33,778.33c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ao",
    className: "cls-6-cookie-p2",
    d: "M287.74,789.81l-4.35-5.91-1.56,1.29v4.62h-2.17v-17.72h2.17v11.07l5.64-6.25h2.51l-5.23,5.57,5.57,7.33h-2.58"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ag-2",
    "data-name": "ag",
    className: "cls-6-cookie-p2",
    d: "M301.05,786.61c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ai-2",
    "data-name": "ai",
    className: "cls-6-cookie-p2",
    d: "M310.63,776.63c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM310.56,788.45c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ap",
    className: "cls-6-cookie-p2",
    d: "M120.47,819.14v-16.84h12.7v1.9h-10.46v5.36h9.78v1.83h-9.78v5.91h11v1.83h-13.24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aq",
    className: "cls-6-cookie-p2",
    d: "M152.79,819.14h-2.72l-3.8-14.26-3.73,14.26h-2.72l-4.96-16.84h2.38l4.01,14.8,1.02-4.35,2.92-10.46h2.17l4.01,14.8,4.01-14.8h2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar",
    className: "cls-6-cookie-p2",
    d: "M159.99,819.14v-16.84h2.31v16.84h-2.31"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ag-3",
    "data-name": "ag",
    className: "cls-6-cookie-p2",
    d: "M175.33,815.95c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ak-2",
    "data-name": "ak",
    className: "cls-6-cookie-p2",
    d: "M184.9,805.97c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM188.44,811.47c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ac-5",
    "data-name": "ac",
    className: "cls-6-cookie-p2",
    d: "M201.27,816.69c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM194.95,815.54c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "as",
    className: "cls-6-cookie-p2",
    d: "M219.53,807.66c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "rect1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1-cookie-p2",
    d: "M.5,6.5C.5,3.19,3.19.5,6.5.5h330.26c3.31,0,6,2.69,6,6v100c0,3.31-2.69,6-6,6H6.5c-3.31,0-6-2.69-6-6V6.5Z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    id: "at",
    className: "cls-6-cookie-p2",
    d: "M97.52,50.15c-.68-1.9-2.38-3.06-4.96-3.06-4.01,0-5.91,2.72-5.91,6.72s1.97,6.86,6.04,6.86c2.92,0,4.21-1.63,5.3-3.53l1.83.95c-1.22,2.58-3.46,4.48-7.27,4.48-5.43,0-7.94-3.4-8.22-8.76-.41-7.06,6.72-10.39,12.7-7.54,1.29.61,2.1,1.77,2.65,3.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ai-3",
    "data-name": "ai",
    className: "cls-6-cookie-p2",
    d: "M107.5,49.13c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM107.43,60.95c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad-3",
    "data-name": "ad",
    className: "cls-6-cookie-p2",
    d: "M122.23,49.13c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ag-4",
    "data-name": "ag",
    className: "cls-6-cookie-p2",
    d: "M131.87,59.11c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ak-3",
    "data-name": "ak",
    className: "cls-6-cookie-p2",
    d: "M141.45,49.13c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM144.98,54.63c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad-4",
    "data-name": "ad",
    className: "cls-6-cookie-p2",
    d: "M156.18,49.13c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ag-5",
    "data-name": "ag",
    className: "cls-6-cookie-p2",
    d: "M165.82,59.11c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    id: "at-2",
    "data-name": "at",
    className: "cls-6-cookie-p2",
    d: "M189.79,50.15c-.68-1.9-2.38-3.06-4.96-3.06-4.01,0-5.91,2.72-5.91,6.72s1.97,6.86,6.04,6.86c2.92,0,4.21-1.63,5.3-3.53l1.83.95c-1.22,2.58-3.46,4.48-7.27,4.48-5.43,0-7.94-3.4-8.22-8.76-.41-7.06,6.72-10.39,12.7-7.54,1.29.61,2.1,1.77,2.65,3.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "au",
    className: "cls-6-cookie-p2",
    d: "M200.18,50.83c-4.89,0-2.99,6.93-3.33,11.48h-2.17v-17.72h2.17l-.07,6.99c.81-1.43,1.9-2.44,4.14-2.44,6.04,0,3.6,7.88,4.07,13.17h-2.17v-8.22c.14-2.17-.54-3.33-2.65-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ac-6",
    "data-name": "ac",
    className: "cls-6-cookie-p2",
    d: "M216.14,59.86c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM209.82,58.71c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad-5",
    "data-name": "ad",
    className: "cls-6-cookie-p2",
    d: "M228.09,49.13c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "av",
    className: "cls-6-cookie-p2",
    d: "M245.74,49.4c-.68,8.49,2.78,19.9-7.47,17.72-1.56-.41-2.58-1.36-2.99-2.92l2.17-.34c1.02,3.19,6.79,2.17,6.04-1.9v-2.04c-.75,1.43-1.97,2.44-4.14,2.44-3.67,0-4.62-2.78-4.62-6.52s1.09-6.59,4.82-6.65c1.97-.07,3.26,1.09,4.01,2.38.07-.68,0-1.56.14-2.17h2.04ZM240.11,60.81c2.44,0,3.4-2.17,3.4-4.96s-.95-5.09-3.4-5.09c-2.65,0-3.12,2.31-3.12,5.09s.41,4.96,3.12,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ak-4",
    "data-name": "ak",
    className: "cls-6-cookie-p2",
    d: "M254.1,49.13c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM257.63,54.63c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "rect2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1-cookie-p2",
    d: "M670.23,6.5c0-3.31,2.69-6,6-6h330.24c3.31,0,6,2.69,6,6v100c0,3.31-2.69,6-6,6h-330.25c-3.31,0-6-2.69-6-6V6.5Z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aw",
    className: "cls-6-cookie-p2",
    d: "M689.39,47.37v6.25h9.37v1.9h-9.37v6.79h-2.24v-16.84h11.88v1.9h-9.64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ax",
    className: "cls-6-cookie-p2",
    d: "M705.68,62.58c-6.04.27-3.67-7.88-4.14-13.17h2.17v8.15c0,2.1.48,3.4,2.65,3.33,4.89-.14,3.06-6.86,3.4-11.48h2.1l.07,12.9h-2.04c-.07-.68.07-1.7-.14-2.24-.75,1.49-1.9,2.44-4.07,2.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad-6",
    "data-name": "ad",
    className: "cls-6-cookie-p2",
    d: "M721.5,49.13c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "an-2",
    "data-name": "an",
    className: "cls-6-cookie-p2",
    d: "M733.66,50.83c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ag-6",
    "data-name": "ag",
    className: "cls-6-cookie-p2",
    d: "M743.37,59.11c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah-2",
    "data-name": "ah",
    className: "cls-6-cookie-p2",
    d: "M747.78,46.62v-2.04h2.17v2.04h-2.17ZM747.78,62.31v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ai-4",
    "data-name": "ai",
    className: "cls-6-cookie-p2",
    d: "M758.31,49.13c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM758.24,60.95c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad-7",
    "data-name": "ad",
    className: "cls-6-cookie-p2",
    d: "M773.04,49.13c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ac-7",
    "data-name": "ac",
    className: "cls-6-cookie-p2",
    d: "M788.25,59.86c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM781.94,58.71c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "af-2",
    "data-name": "af",
    className: "cls-6-cookie-p2",
    d: "M793.89,62.31v-17.72h2.17v17.72h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ay",
    className: "cls-6-cookie-p2",
    d: "M797.62,62.58l4.89-17.99h1.9l-4.89,17.99h-1.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aa-2",
    "data-name": "aa",
    className: "cls-6-cookie-p2",
    d: "M813.04,47.37v14.94h-2.31v-14.94h-5.77v-1.9h13.85v1.9h-5.77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ak-5",
    "data-name": "ak",
    className: "cls-6-cookie-p2",
    d: "M823.36,49.13c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM826.89,54.63c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "an-3",
    "data-name": "an",
    className: "cls-6-cookie-p2",
    d: "M836.66,50.83c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "au-2",
    "data-name": "au",
    className: "cls-6-cookie-p2",
    d: "M849.57,50.83c-4.89,0-2.99,6.93-3.33,11.48h-2.17v-17.72h2.17l-.07,6.99c.81-1.43,1.9-2.44,4.14-2.44,6.04,0,3.6,7.88,4.07,13.17h-2.17v-8.22c.14-2.17-.54-3.33-2.65-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad-8",
    "data-name": "ad",
    className: "cls-6-cookie-p2",
    d: "M863.89,49.13c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah-3",
    "data-name": "ah",
    className: "cls-6-cookie-p2",
    d: "M871.16,46.62v-2.04h2.17v2.04h-2.17ZM871.16,62.31v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "an-4",
    "data-name": "an",
    className: "cls-6-cookie-p2",
    d: "M881.41,50.83c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ac-8",
    "data-name": "ac",
    className: "cls-6-cookie-p2",
    d: "M896.69,59.86c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM890.37,58.71c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "af-3",
    "data-name": "af",
    className: "cls-6-cookie-p2",
    d: "M902.33,62.31v-17.72h2.17v17.72h-2.17"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    id: "at-3",
    "data-name": "at",
    className: "cls-6-cookie-p2",
    d: "M927.24,50.15c-.68-1.9-2.38-3.06-4.96-3.06-4.01,0-5.91,2.72-5.91,6.72s1.97,6.86,6.04,6.86c2.92,0,4.21-1.63,5.3-3.53l1.83.95c-1.22,2.58-3.46,4.48-7.27,4.48-5.43,0-7.94-3.4-8.22-8.76-.41-7.06,6.72-10.39,12.7-7.54,1.29.61,2.1,1.77,2.65,3.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "au-3",
    "data-name": "au",
    className: "cls-6-cookie-p2",
    d: "M937.63,50.83c-4.89,0-2.99,6.93-3.33,11.48h-2.17v-17.72h2.17l-.07,6.99c.81-1.43,1.9-2.44,4.14-2.44,6.04,0,3.6,7.88,4.07,13.17h-2.17v-8.22c.14-2.17-.54-3.33-2.65-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ac-9",
    "data-name": "ac",
    className: "cls-6-cookie-p2",
    d: "M953.59,59.86c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM947.28,58.71c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad-9",
    "data-name": "ad",
    className: "cls-6-cookie-p2",
    d: "M965.54,49.13c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "av-2",
    "data-name": "av",
    className: "cls-6-cookie-p2",
    d: "M983.2,49.4c-.68,8.49,2.78,19.9-7.47,17.72-1.56-.41-2.58-1.36-2.99-2.92l2.17-.34c1.02,3.19,6.79,2.17,6.04-1.9v-2.04c-.75,1.43-1.97,2.44-4.14,2.44-3.67,0-4.62-2.78-4.62-6.52s1.09-6.59,4.82-6.65c1.97-.07,3.26,1.09,4.01,2.38.07-.68,0-1.56.14-2.17h2.04ZM977.56,60.81c2.44,0,3.4-2.17,3.4-4.96s-.95-5.09-3.4-5.09c-2.65,0-3.12,2.31-3.12,5.09s.41,4.96,3.12,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ak-6",
    "data-name": "ak",
    className: "cls-6-cookie-p2",
    d: "M991.55,49.13c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM995.08,54.63c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "rect3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1-cookie-p2",
    d: "M.5,186.5c0-3.31,2.69-6,6-6h330.26c3.31,0,6,2.69,6,6v100c0,3.31-2.69,6-6,6H6.5c-3.31,0-6-2.69-6-6v-100Z"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "a-2",
    "data-name": "a"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aa-3",
    "data-name": "aa",
    className: "cls-6-cookie-p2",
    d: "M61.8,212.43v14.94h-2.31v-14.94h-5.77v-1.9h13.85v1.9h-5.77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ab-2",
    "data-name": "ab",
    className: "cls-6-cookie-p2",
    d: "M74.9,216.3c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ac-10",
    "data-name": "ac",
    className: "cls-6-cookie-p2",
    d: "M84.82,224.92c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM78.5,223.77c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad-10",
    "data-name": "ad",
    className: "cls-6-cookie-p2",
    d: "M96.77,214.2c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ae-4",
    "data-name": "ae",
    className: "cls-6-cookie-p2",
    d: "M111.57,217.66c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "af-4",
    "data-name": "af",
    className: "cls-6-cookie-p2",
    d: "M116.26,227.37v-17.72h2.17v17.72h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ac-11",
    "data-name": "ac",
    className: "cls-6-cookie-p2",
    d: "M129.56,224.92c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM123.25,223.77c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ag-7",
    "data-name": "ag",
    className: "cls-6-cookie-p2",
    d: "M137.58,224.18c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah-4",
    "data-name": "ah",
    className: "cls-6-cookie-p2",
    d: "M141.99,211.68v-2.04h2.17v2.04h-2.17ZM141.99,227.37v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ai-5",
    "data-name": "ai",
    className: "cls-6-cookie-p2",
    d: "M152.52,214.2c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM152.45,226.01c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad-11",
    "data-name": "ad",
    className: "cls-6-cookie-p2",
    d: "M167.25,214.2c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aa-4",
    "data-name": "aa",
    className: "cls-6-cookie-p2",
    d: "M188.3,212.43v14.94h-2.31v-14.94h-5.77v-1.9h13.85v1.9h-5.77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ak-7",
    "data-name": "ak",
    className: "cls-6-cookie-p2",
    d: "M198.62,214.2c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM202.15,219.7c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "as-2",
    "data-name": "as",
    className: "cls-6-cookie-p2",
    d: "M219.67,215.89c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aj-2",
    "data-name": "aj",
    className: "cls-6-cookie-p2",
    d: "M233.52,214.2c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31ZM232.98,226.01c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "af-5",
    "data-name": "af",
    className: "cls-6-cookie-p2",
    d: "M240.92,227.37v-17.72h2.17v17.72h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ac-12",
    "data-name": "ac",
    className: "cls-6-cookie-p2",
    d: "M254.23,224.92c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM247.92,223.77c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ag-8",
    "data-name": "ag",
    className: "cls-6-cookie-p2",
    d: "M262.24,224.18c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ak-8",
    "data-name": "ak",
    className: "cls-6-cookie-p2",
    d: "M271.82,214.2c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM275.35,219.7c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ae-5",
    "data-name": "ae",
    className: "cls-6-cookie-p2",
    d: "M287.77,217.66c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "l"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aj-3",
    "data-name": "aj",
    className: "cls-6-cookie-p2",
    d: "M133.03,243.53c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31ZM132.49,255.34c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ab-3",
    "data-name": "ab",
    className: "cls-6-cookie-p2",
    d: "M146.54,245.63c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ai-6",
    "data-name": "ai",
    className: "cls-6-cookie-p2",
    d: "M153.67,243.53c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM153.6,255.34c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "az",
    className: "cls-6-cookie-p2",
    d: "M167.79,256.7h-2.58l-4.69-12.9h2.31l3.67,11.2,3.8-11.2h2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah-5",
    "data-name": "ah",
    className: "cls-6-cookie-p2",
    d: "M174.31,241.02v-2.04h2.17v2.04h-2.17ZM174.31,256.7v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "al-2",
    "data-name": "al",
    className: "cls-6-cookie-p2",
    d: "M183.82,243.53c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM184.43,245.16c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ak-9",
    "data-name": "ak",
    className: "cls-6-cookie-p2",
    d: "M198.42,243.53c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM201.95,249.03c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "al-3",
    "data-name": "al",
    className: "cls-6-cookie-p2",
    d: "M210.98,243.53c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM211.59,245.16c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "rect5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1-cookie-p2",
    d: "M.5,374.5c0-3.31,2.69-6,6-6h330.26c3.31,0,6,2.69,6,6v100c0,3.31-2.69,6-6,6H6.5c-3.31,0-6-2.69-6-6v-100Z"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "a-3",
    "data-name": "a"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aa-5",
    "data-name": "aa",
    className: "cls-6-cookie-p2",
    d: "M25.17,415.37v14.94h-2.31v-14.94h-5.77v-1.9h13.85v1.9h-5.77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ab-4",
    "data-name": "ab",
    className: "cls-6-cookie-p2",
    d: "M38.27,419.24c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ac-13",
    "data-name": "ac",
    className: "cls-6-cookie-p2",
    d: "M48.19,427.86c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM41.87,426.71c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad-12",
    "data-name": "ad",
    className: "cls-6-cookie-p2",
    d: "M60.14,417.13c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ae-6",
    "data-name": "ae",
    className: "cls-6-cookie-p2",
    d: "M74.94,420.6c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "af-6",
    "data-name": "af",
    className: "cls-6-cookie-p2",
    d: "M79.63,430.31v-17.72h2.17v17.72h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ac-14",
    "data-name": "ac",
    className: "cls-6-cookie-p2",
    d: "M92.93,427.86c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM86.62,426.71c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ag-9",
    "data-name": "ag",
    className: "cls-6-cookie-p2",
    d: "M100.95,427.11c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah-6",
    "data-name": "ah",
    className: "cls-6-cookie-p2",
    d: "M105.36,414.62v-2.04h2.17v2.04h-2.17ZM105.36,430.31v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ai-7",
    "data-name": "ai",
    className: "cls-6-cookie-p2",
    d: "M115.88,417.13c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM115.82,428.95c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad-13",
    "data-name": "ad",
    className: "cls-6-cookie-p2",
    d: "M130.62,417.13c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ab-5",
    "data-name": "ab",
    className: "cls-6-cookie-p2",
    d: "M150.79,419.24c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ak-10",
    "data-name": "ak",
    className: "cls-6-cookie-p2",
    d: "M157.92,417.13c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM161.45,422.63c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "az-2",
    "data-name": "az",
    className: "cls-6-cookie-p2",
    d: "M172.04,430.31h-2.58l-4.69-12.9h2.31l3.67,11.2,3.8-11.2h2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah-7",
    "data-name": "ah",
    className: "cls-6-cookie-p2",
    d: "M178.56,414.62v-2.04h2.17v2.04h-2.17ZM178.56,430.31v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ak-11",
    "data-name": "ak",
    className: "cls-6-cookie-p2",
    d: "M189.08,417.13c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM192.61,422.63c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aA",
    className: "cls-6-cookie-p2",
    d: "M209.86,430.31h-2.44l-2.72-11.14-2.78,11.14h-2.44l-3.67-12.9h2.17l2.65,11.14,2.92-11.14h2.31l2.78,11.14,2.85-11.14h2.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ak-12",
    "data-name": "ak",
    className: "cls-6-cookie-p2",
    d: "M220.25,417.13c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM223.78,422.63c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "al-4",
    "data-name": "al",
    className: "cls-6-cookie-p2",
    d: "M232.81,417.13c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM233.42,418.76c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "n"
  }, /*#__PURE__*/React.createElement("path", {
    id: "am-2",
    "data-name": "am",
    className: "cls-6-cookie-p2",
    d: "M255.22,417.13c3.6,0,4.69,2.65,4.75,6.65,0,4.48-1.56,6.79-4.75,6.79-2.1-.07-3.33-.75-4.01-2.31l-.14,2.04h-2.1l.07-17.72h2.17v6.86c.68-1.56,1.9-2.31,4.01-2.31ZM254.67,428.95c2.72,0,3.06-2.31,3.06-5.09s-.34-5.09-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aB",
    className: "cls-6-cookie-p2",
    d: "M273.14,417.4l-5.84,15.01c-.95,1.9-2.51,3.46-5.5,2.85v-1.63c2.65.41,3.6-1.36,4.35-3.4l-5.09-12.83h2.31l3.87,10.59,3.67-10.59h2.24"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "o"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aC",
    className: "cls-6-cookie-p2",
    d: "M282.04,413.47c5.91.07,12.97-1.02,12.97,5.09,0,5.3-5.23,5.43-10.73,5.16v6.59h-2.24v-16.84ZM284.28,421.95c3.87,0,8.42.75,8.42-3.4s-4.62-3.19-8.42-3.26v6.65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ai-8",
    "data-name": "ai",
    className: "cls-6-cookie-p2",
    d: "M303.09,417.13c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM303.02,428.95c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-4",
    "data-name": "at",
    className: "cls-6-cookie-p2",
    d: "M324.27,418.15c-.68-1.9-2.38-3.06-4.96-3.06-4.01,0-5.91,2.72-5.91,6.72s1.97,6.86,6.04,6.86c2.92,0,4.21-1.63,5.3-3.53l1.83.95c-1.22,2.58-3.46,4.48-7.27,4.48-5.43,0-7.94-3.4-8.22-8.76-.41-7.06,6.72-10.39,12.7-7.54,1.29.61,2.1,1.77,2.65,3.12"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "rect9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1-cookie-p2",
    d: "M.5,946.5c0-3.31,2.69-6,6-6h330.26c3.31,0,6,2.69,6,6v100c0,3.31-2.69,6-6,6H6.5c-3.31,0-6-2.69-6-6v-100Z"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "p"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ap-2",
    "data-name": "ap",
    className: "cls-6-cookie-p2",
    d: "M50.63,1000.12v-16.84h12.7v1.9h-10.46v5.36h9.78v1.83h-9.78v5.91h11v1.83h-13.24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aq-2",
    "data-name": "aq",
    className: "cls-6-cookie-p2",
    d: "M82.95,1000.12h-2.72l-3.8-14.26-3.73,14.26h-2.72l-4.96-16.84h2.38l4.01,14.8,1.02-4.35,2.92-10.46h2.17l4.01,14.8,4.01-14.8h2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar-2",
    "data-name": "ar",
    className: "cls-6-cookie-p2",
    d: "M90.15,1000.12v-16.84h2.31v16.84h-2.31"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "q"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aj-4",
    "data-name": "aj",
    className: "cls-6-cookie-p2",
    d: "M109.3,986.95c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31ZM108.75,998.76c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ab-6",
    "data-name": "ab",
    className: "cls-6-cookie-p2",
    d: "M122.81,989.05c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ai-9",
    "data-name": "ai",
    className: "cls-6-cookie-p2",
    d: "M129.94,986.95c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM129.87,998.76c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "az-3",
    "data-name": "az",
    className: "cls-6-cookie-p2",
    d: "M144.06,1000.12h-2.58l-4.69-12.9h2.31l3.67,11.2,3.8-11.2h2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah-8",
    "data-name": "ah",
    className: "cls-6-cookie-p2",
    d: "M150.58,984.43v-2.04h2.17v2.04h-2.17ZM150.58,1000.12v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "al-5",
    "data-name": "al",
    className: "cls-6-cookie-p2",
    d: "M160.09,986.95c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM160.7,988.58c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ak-13",
    "data-name": "ak",
    className: "cls-6-cookie-p2",
    d: "M174.69,986.95c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM178.22,992.45c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ae-7",
    "data-name": "ae",
    className: "cls-6-cookie-p2",
    d: "M190.64,990.41c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "r"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ag-10",
    "data-name": "ag",
    className: "cls-6-cookie-p2",
    d: "M204.49,996.93c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ak-14",
    "data-name": "ak",
    className: "cls-6-cookie-p2",
    d: "M214.07,986.95c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM217.6,992.45c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ae-8",
    "data-name": "ae",
    className: "cls-6-cookie-p2",
    d: "M230.03,990.41c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ag-11",
    "data-name": "ag",
    className: "cls-6-cookie-p2",
    d: "M237.09,996.93c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "s"
  }, /*#__PURE__*/React.createElement("path", {
    id: "af-7",
    "data-name": "af",
    className: "cls-6-cookie-p2",
    d: "M248.29,1000.12v-17.72h2.17v17.72h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah-9",
    "data-name": "ah",
    className: "cls-6-cookie-p2",
    d: "M253.66,984.43v-2.04h2.17v2.04h-2.17ZM253.66,1000.12v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad-14",
    "data-name": "ad",
    className: "cls-6-cookie-p2",
    d: "M265.33,986.95c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ao-2",
    "data-name": "ao",
    className: "cls-6-cookie-p2",
    d: "M280.68,1000.12l-4.35-5.91-1.56,1.29v4.62h-2.17v-17.72h2.17v11.07l5.64-6.25h2.51l-5.23,5.57,5.57,7.33h-2.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ae-9",
    "data-name": "ae",
    className: "cls-6-cookie-p2",
    d: "M292.36,990.41c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "rect11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1-cookie-p2",
    d: "M.5,1126.5c0-3.31,2.69-6,6-6h330.26c3.31,0,6,2.69,6,6v100c0,3.31-2.69,6-6,6H6.5c-3.31,0-6-2.69-6-6v-100Z"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "t"
  }, /*#__PURE__*/React.createElement("path", {
    id: "at-5",
    "data-name": "at",
    className: "cls-6-cookie-p2",
    d: "M30.36,1167.96c-.68-1.9-2.38-3.06-4.96-3.06-4.01,0-5.91,2.72-5.91,6.72s1.97,6.86,6.04,6.86c2.92,0,4.21-1.63,5.3-3.53l1.83.95c-1.22,2.58-3.46,4.48-7.27,4.48-5.43,0-7.94-3.4-8.22-8.76-.41-7.06,6.72-10.39,12.7-7.54,1.29.61,2.1,1.77,2.65,3.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ax-2",
    "data-name": "ax",
    className: "cls-6-cookie-p2",
    d: "M39.26,1180.39c-6.04.27-3.67-7.88-4.14-13.17h2.17v8.15c0,2.1.48,3.4,2.65,3.33,4.89-.14,3.06-6.86,3.4-11.48h2.1l.07,12.9h-2.04c-.07-.68.07-1.7-.14-2.24-.75,1.49-1.9,2.44-4.07,2.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ae-10",
    "data-name": "ae",
    className: "cls-6-cookie-p2",
    d: "M56.3,1170.41c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ag-12",
    "data-name": "ag",
    className: "cls-6-cookie-p2",
    d: "M63.36,1176.93c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ai-10",
    "data-name": "ai",
    className: "cls-6-cookie-p2",
    d: "M72.94,1166.95c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM72.87,1178.76c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "al-6",
    "data-name": "al",
    className: "cls-6-cookie-p2",
    d: "M85.5,1166.95c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM86.11,1168.58c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah-10",
    "data-name": "ah",
    className: "cls-6-cookie-p2",
    d: "M94.94,1164.43v-2.04h2.17v2.04h-2.17ZM94.94,1180.12v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ac-15",
    "data-name": "ac",
    className: "cls-6-cookie-p2",
    d: "M108.24,1177.67c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM101.93,1176.52c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad-15",
    "data-name": "ad",
    className: "cls-6-cookie-p2",
    d: "M120.2,1166.95c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "u"
  }, /*#__PURE__*/React.createElement("path", {
    id: "az-4",
    "data-name": "az",
    className: "cls-6-cookie-p2",
    d: "M139.95,1180.12h-2.58l-4.69-12.9h2.31l3.67,11.2,3.8-11.2h2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ac-16",
    "data-name": "ac",
    className: "cls-6-cookie-p2",
    d: "M154.42,1177.67c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM148.1,1176.52c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "af-8",
    "data-name": "af",
    className: "cls-6-cookie-p2",
    d: "M160.05,1180.12v-17.72h2.17v17.72h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah-11",
    "data-name": "ah",
    className: "cls-6-cookie-p2",
    d: "M165.42,1164.43v-2.04h2.17v2.04h-2.17ZM165.42,1180.12v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "al-7",
    "data-name": "al",
    className: "cls-6-cookie-p2",
    d: "M174.92,1166.95c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM175.53,1168.58c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ac-17",
    "data-name": "ac",
    className: "cls-6-cookie-p2",
    d: "M192.31,1177.67c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM185.99,1176.52c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ag-13",
    "data-name": "ag",
    className: "cls-6-cookie-p2",
    d: "M200.32,1176.93c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ak-15",
    "data-name": "ak",
    className: "cls-6-cookie-p2",
    d: "M209.89,1166.95c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM213.42,1172.45c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ae-11",
    "data-name": "ae",
    className: "cls-6-cookie-p2",
    d: "M225.85,1170.41c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "v"
  }, /*#__PURE__*/React.createElement("path", {
    id: "an-5",
    "data-name": "an",
    className: "cls-6-cookie-p2",
    d: "M242.21,1168.64c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "au-4",
    "data-name": "au",
    className: "cls-6-cookie-p2",
    d: "M255.12,1168.64c-4.89,0-2.99,6.93-3.33,11.48h-2.17v-17.72h2.17l-.07,6.99c.81-1.43,1.9-2.44,4.14-2.44,6.04,0,3.6,7.88,4.07,13.17h-2.17v-8.22c.14-2.17-.54-3.33-2.65-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ac-18",
    "data-name": "ac",
    className: "cls-6-cookie-p2",
    d: "M271.07,1177.67c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM264.76,1176.52c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad-16",
    "data-name": "ad",
    className: "cls-6-cookie-p2",
    d: "M283.02,1166.95c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "av-3",
    "data-name": "av",
    className: "cls-6-cookie-p2",
    d: "M300.68,1167.22c-.68,8.49,2.78,19.9-7.47,17.72-1.56-.41-2.58-1.36-2.99-2.92l2.17-.34c1.02,3.19,6.79,2.17,6.04-1.9v-2.04c-.75,1.43-1.97,2.44-4.14,2.44-3.67,0-4.62-2.78-4.62-6.52s1.09-6.59,4.82-6.65c1.97-.07,3.26,1.09,4.01,2.38.07-.68,0-1.56.14-2.17h2.04ZM295.04,1178.62c2.44,0,3.4-2.17,3.4-4.96s-.95-5.09-3.4-5.09c-2.65,0-3.12,2.31-3.12,5.09s.41,4.96,3.12,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ak-16",
    "data-name": "ak",
    className: "cls-6-cookie-p2",
    d: "M309.03,1166.95c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM312.56,1172.45c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ae-12",
    "data-name": "ae",
    className: "cls-6-cookie-p2",
    d: "M324.99,1170.41c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "rect7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1-cookie-p2",
    d: "M.5,562.5c0-3.31,2.69-6,6-6h330.26c3.31,0,6,2.69,6,6v100c0,3.31-2.69,6-6,6H6.5c-3.31,0-6-2.69-6-6v-100Z"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "w"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aD",
    className: "cls-6-cookie-p2",
    d: "M39.83,584.97c-.54,6.79,2.38,17.11-4.96,17.11-2.99-.07-4.55-1.7-5.02-4.48l2.17-.34c.27,1.7,1.09,2.85,2.92,2.92,1.83,0,2.65-1.36,2.65-3.33v-9.98h-3.26v-1.9h5.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ai-11",
    "data-name": "ai",
    className: "cls-6-cookie-p2",
    d: "M48.46,588.63c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM48.39,600.45c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "am-3",
    "data-name": "am",
    className: "cls-6-cookie-p2",
    d: "M63.06,588.63c3.6,0,4.69,2.65,4.75,6.65,0,4.48-1.56,6.79-4.75,6.79-2.1-.07-3.33-.75-4.01-2.31l-.14,2.04h-2.1l.07-17.72h2.17v6.86c.68-1.56,1.9-2.31,4.01-2.31ZM62.51,600.45c2.72,0,3.06-2.31,3.06-5.09s-.34-5.09-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "x"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aE",
    className: "cls-6-cookie-p2",
    d: "M86.48,592.91c2.38.34,4.14,1.56,4.14,4.14,0,5.91-7.2,4.62-12.97,4.75v-16.84c5.16.2,12.02-1.15,12.02,4.07,0,2.24-1.29,3.4-3.19,3.87ZM79.89,592.16c3.4-.07,7.47.61,7.47-2.85,0-3.19-4.28-2.44-7.47-2.51v5.36ZM79.89,599.97c3.73-.14,8.42.95,8.42-3.06s-4.75-2.85-8.42-2.99v6.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ac-19",
    "data-name": "ac",
    className: "cls-6-cookie-p2",
    d: "M101.49,599.36c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM95.17,598.21c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "av-4",
    "data-name": "av",
    className: "cls-6-cookie-p2",
    d: "M117.51,588.9c-.68,8.49,2.78,19.9-7.47,17.72-1.56-.41-2.58-1.36-2.99-2.92l2.17-.34c1.02,3.19,6.79,2.17,6.04-1.9v-2.04c-.75,1.43-1.97,2.44-4.14,2.44-3.67,0-4.62-2.78-4.62-6.52s1.09-6.59,4.82-6.65c1.97-.07,3.26,1.09,4.01,2.38.07-.68,0-1.56.14-2.17h2.04ZM111.88,600.31c2.44,0,3.4-2.17,3.4-4.96s-.95-5.09-3.4-5.09c-2.65,0-3.12,2.31-3.12,5.09s.41,4.96,3.12,4.96"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "y"
  }, /*#__PURE__*/React.createElement("path", {
    id: "an-6",
    "data-name": "an",
    className: "cls-6-cookie-p2",
    d: "M132.38,590.33c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ab-7",
    "data-name": "ab",
    className: "cls-6-cookie-p2",
    d: "M145.83,590.74c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ak-17",
    "data-name": "ak",
    className: "cls-6-cookie-p2",
    d: "M152.96,588.63c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM156.49,594.13c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ac-20",
    "data-name": "ac",
    className: "cls-6-cookie-p2",
    d: "M169.32,599.36c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM163.01,598.21c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ag-14",
    "data-name": "ag",
    className: "cls-6-cookie-p2",
    d: "M177.33,598.61c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ak-18",
    "data-name": "ak",
    className: "cls-6-cookie-p2",
    d: "M186.91,588.63c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM190.44,594.13c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "al-8",
    "data-name": "al",
    className: "cls-6-cookie-p2",
    d: "M199.47,588.63c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM200.08,590.26c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "z"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ac-21",
    "data-name": "ac",
    className: "cls-6-cookie-p2",
    d: "M223.64,599.36c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM217.33,598.21c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad-17",
    "data-name": "ad",
    className: "cls-6-cookie-p2",
    d: "M235.59,588.63c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "al-9",
    "data-name": "al",
    className: "cls-6-cookie-p2",
    d: "M247,588.63c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM247.61,590.26c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "A"
  }, /*#__PURE__*/React.createElement("path", {
    id: "an-7",
    "data-name": "an",
    className: "cls-6-cookie-p2",
    d: "M268.12,590.33c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ai-12",
    "data-name": "ai",
    className: "cls-6-cookie-p2",
    d: "M280.61,588.63c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM280.54,600.45c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "al-10",
    "data-name": "al",
    className: "cls-6-cookie-p2",
    d: "M293.17,588.63c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM293.78,590.26c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ak-19",
    "data-name": "ak",
    className: "cls-6-cookie-p2",
    d: "M307.77,588.63c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM311.3,594.13c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "B"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ac-22",
    "data-name": "ac",
    className: "cls-6-cookie-p2",
    d: "M24.22,628.69c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM17.9,627.54c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "al-11",
    "data-name": "al",
    className: "cls-6-cookie-p2",
    d: "M33.99,617.97c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM34.61,619.6c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "al-12",
    "data-name": "al",
    className: "cls-6-cookie-p2",
    d: "M47.57,617.97c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM48.19,619.6c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ak-20",
    "data-name": "ak",
    className: "cls-6-cookie-p2",
    d: "M62.17,617.97c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM65.7,623.47c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "al-13",
    "data-name": "al",
    className: "cls-6-cookie-p2",
    d: "M74.74,617.97c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM75.35,619.6c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "C"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ag-15",
    "data-name": "ag",
    className: "cls-6-cookie-p2",
    d: "M93.34,627.95c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ai-13",
    "data-name": "ai",
    className: "cls-6-cookie-p2",
    d: "M102.91,617.97c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM102.85,629.78c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "D"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ag-16",
    "data-name": "ag",
    className: "cls-6-cookie-p2",
    d: "M120.5,627.95c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ab-8",
    "data-name": "ab",
    className: "cls-6-cookie-p2",
    d: "M131.03,620.07c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ac-23",
    "data-name": "ac",
    className: "cls-6-cookie-p2",
    d: "M140.94,628.69c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM134.62,627.54c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad-18",
    "data-name": "ad",
    className: "cls-6-cookie-p2",
    d: "M152.89,617.97c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ae-13",
    "data-name": "ae",
    className: "cls-6-cookie-p2",
    d: "M167.69,621.43c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "af-9",
    "data-name": "af",
    className: "cls-6-cookie-p2",
    d: "M172.38,631.14v-17.72h2.17v17.72h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ac-24",
    "data-name": "ac",
    className: "cls-6-cookie-p2",
    d: "M185.69,628.69c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM179.37,627.54c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ag-17",
    "data-name": "ag",
    className: "cls-6-cookie-p2",
    d: "M193.7,627.95c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah-12",
    "data-name": "ah",
    className: "cls-6-cookie-p2",
    d: "M198.11,615.45v-2.04h2.17v2.04h-2.17ZM198.11,631.14v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ai-14",
    "data-name": "ai",
    className: "cls-6-cookie-p2",
    d: "M208.64,617.97c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM208.57,629.78c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad-19",
    "data-name": "ad",
    className: "cls-6-cookie-p2",
    d: "M223.37,617.97c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "E"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ag-18",
    "data-name": "ag",
    className: "cls-6-cookie-p2",
    d: "M239.8,627.95c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ak-21",
    "data-name": "ak",
    className: "cls-6-cookie-p2",
    d: "M249.38,617.97c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM252.91,623.47c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "as-3",
    "data-name": "as",
    className: "cls-6-cookie-p2",
    d: "M270.43,619.66c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aj-5",
    "data-name": "aj",
    className: "cls-6-cookie-p2",
    d: "M284.28,617.97c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31ZM283.74,629.78c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "af-10",
    "data-name": "af",
    className: "cls-6-cookie-p2",
    d: "M291.68,631.14v-17.72h2.17v17.72h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ac-25",
    "data-name": "ac",
    className: "cls-6-cookie-p2",
    d: "M304.99,628.69c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM298.67,627.54c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ag-19",
    "data-name": "ag",
    className: "cls-6-cookie-p2",
    d: "M313,627.95c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ak-22",
    "data-name": "ak",
    className: "cls-6-cookie-p2",
    d: "M322.57,617.97c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM326.11,623.47c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    id: "rect4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1-cookie-p2",
    d: "M670.23,186.5c0-3.31,2.69-6,6-6h330.24c3.31,0,6,2.69,6,6v100c0,3.31-2.69,6-6,6h-330.25c-3.31,0-6-2.69-6-6v-100Z"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    id: "p-2",
    "data-name": "p"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ap-3",
    "data-name": "ap",
    className: "cls-6-cookie-p2",
    d: "M726.46,240.12v-16.84h12.7v1.9h-10.46v5.36h9.78v1.83h-9.78v5.91h11v1.83h-13.24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aq-3",
    "data-name": "aq",
    className: "cls-6-cookie-p2",
    d: "M758.78,240.12h-2.72l-3.8-14.26-3.73,14.26h-2.72l-4.96-16.84h2.38l4.01,14.8,1.02-4.35,2.92-10.46h2.17l4.01,14.8,4.01-14.8h2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar-3",
    "data-name": "ar",
    className: "cls-6-cookie-p2",
    d: "M765.98,240.12v-16.84h2.31v16.84h-2.31"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    id: "q-2",
    "data-name": "q"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aj-6",
    "data-name": "aj",
    className: "cls-6-cookie-p2",
    d: "M785.13,226.95c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31ZM784.58,238.76c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ab-9",
    "data-name": "ab",
    className: "cls-6-cookie-p2",
    d: "M798.64,229.05c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ai-15",
    "data-name": "ai",
    className: "cls-6-cookie-p2",
    d: "M805.77,226.95c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM805.7,238.76c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "az-5",
    "data-name": "az",
    className: "cls-6-cookie-p2",
    d: "M819.89,240.12h-2.58l-4.69-12.9h2.31l3.67,11.2,3.8-11.2h2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah-13",
    "data-name": "ah",
    className: "cls-6-cookie-p2",
    d: "M826.41,224.43v-2.04h2.17v2.04h-2.17ZM826.41,240.12v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "al-14",
    "data-name": "al",
    className: "cls-6-cookie-p2",
    d: "M835.92,226.95c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM836.53,228.58c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ak-23",
    "data-name": "ak",
    className: "cls-6-cookie-p2",
    d: "M850.52,226.95c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM854.05,232.45c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ae-14",
    "data-name": "ae",
    className: "cls-6-cookie-p2",
    d: "M866.47,230.41c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    id: "r-2",
    "data-name": "r"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ag-20",
    "data-name": "ag",
    className: "cls-6-cookie-p2",
    d: "M880.32,236.93c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ak-24",
    "data-name": "ak",
    className: "cls-6-cookie-p2",
    d: "M889.9,226.95c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM893.43,232.45c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ae-15",
    "data-name": "ae",
    className: "cls-6-cookie-p2",
    d: "M905.86,230.41c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ag-21",
    "data-name": "ag",
    className: "cls-6-cookie-p2",
    d: "M912.92,236.93c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    id: "F"
  }, /*#__PURE__*/React.createElement("path", {
    id: "af-11",
    "data-name": "af",
    className: "cls-6-cookie-p2",
    d: "M924.12,240.12v-17.72h2.17v17.72h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah-14",
    "data-name": "ah",
    className: "cls-6-cookie-p2",
    d: "M929.48,224.43v-2.04h2.17v2.04h-2.17ZM929.48,240.12v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad-20",
    "data-name": "ad",
    className: "cls-6-cookie-p2",
    d: "M941.16,226.95c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ao-3",
    "data-name": "ao",
    className: "cls-6-cookie-p2",
    d: "M956.51,240.12l-4.35-5.91-1.56,1.29v4.62h-2.17v-17.72h2.17v11.07l5.64-6.25h2.51l-5.23,5.57,5.57,7.33h-2.58"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    id: "rect6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1-cookie-p2",
    d: "M672.26,374.5c0-3.31,2.69-6,6-6h330.25c3.31,0,6,2.69,6,6v100c0,3.31-2.69,6-6,6h-330.25c-3.31,0-6-2.69-6-6v-100Z"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    id: "t-2",
    "data-name": "t"
  }, /*#__PURE__*/React.createElement("path", {
    id: "at-6",
    "data-name": "at",
    className: "cls-6-cookie-p2",
    d: "M717.36,415.96c-.68-1.9-2.38-3.06-4.96-3.06-4.01,0-5.91,2.72-5.91,6.72s1.97,6.86,6.04,6.86c2.92,0,4.21-1.63,5.3-3.53l1.83.95c-1.22,2.58-3.46,4.48-7.27,4.48-5.43,0-7.94-3.4-8.22-8.76-.41-7.06,6.72-10.39,12.7-7.54,1.29.61,2.1,1.77,2.65,3.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ax-3",
    "data-name": "ax",
    className: "cls-6-cookie-p2",
    d: "M726.25,428.39c-6.04.27-3.67-7.88-4.14-13.17h2.17v8.15c0,2.1.48,3.4,2.65,3.33,4.89-.14,3.06-6.86,3.4-11.48h2.1l.07,12.9h-2.04c-.07-.68.07-1.7-.14-2.24-.75,1.49-1.9,2.44-4.07,2.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ae-16",
    "data-name": "ae",
    className: "cls-6-cookie-p2",
    d: "M743.3,418.41c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ag-22",
    "data-name": "ag",
    className: "cls-6-cookie-p2",
    d: "M750.36,424.93c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ai-16",
    "data-name": "ai",
    className: "cls-6-cookie-p2",
    d: "M759.93,414.95c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM759.86,426.76c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "al-15",
    "data-name": "al",
    className: "cls-6-cookie-p2",
    d: "M772.49,414.95c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM773.1,416.58c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah-15",
    "data-name": "ah",
    className: "cls-6-cookie-p2",
    d: "M781.93,412.43v-2.04h2.17v2.04h-2.17ZM781.93,428.12v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ac-26",
    "data-name": "ac",
    className: "cls-6-cookie-p2",
    d: "M795.24,425.67c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM788.93,424.52c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad-21",
    "data-name": "ad",
    className: "cls-6-cookie-p2",
    d: "M807.19,414.95c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    id: "G"
  }, /*#__PURE__*/React.createElement("path", {
    id: "an-8",
    "data-name": "an",
    className: "cls-6-cookie-p2",
    d: "M826.14,416.64c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ai-17",
    "data-name": "ai",
    className: "cls-6-cookie-p2",
    d: "M838.63,414.95c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM838.56,426.76c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "as-4",
    "data-name": "as",
    className: "cls-6-cookie-p2",
    d: "M859.68,416.64c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aj-7",
    "data-name": "aj",
    className: "cls-6-cookie-p2",
    d: "M873.53,414.95c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31ZM872.99,426.76c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "af-12",
    "data-name": "af",
    className: "cls-6-cookie-p2",
    d: "M880.93,428.12v-17.72h2.17v17.72h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ak-25",
    "data-name": "ak",
    className: "cls-6-cookie-p2",
    d: "M891.46,414.95c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM894.99,420.45c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ag-23",
    "data-name": "ag",
    className: "cls-6-cookie-p2",
    d: "M902.25,424.93c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ak-26",
    "data-name": "ak",
    className: "cls-6-cookie-p2",
    d: "M911.83,414.95c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM915.36,420.45c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ae-17",
    "data-name": "ae",
    className: "cls-6-cookie-p2",
    d: "M927.78,418.41c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    id: "H"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aF",
    className: "cls-6-cookie-p2",
    d: "M953.38,421.8c-.07,4.41-2.72,6.59-7.06,6.59s-6.79-2.17-6.79-6.38v-10.73h2.24c.54,6.04-2.24,15.21,4.55,15.21s4.35-9.03,4.82-15.21h2.24v10.52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aG",
    className: "cls-6-cookie-p2",
    d: "M969.14,428.12l-1.9-4.89h-7.67l-1.9,4.89h-2.38l6.86-16.84h2.58l6.72,16.84h-2.31ZM966.55,421.4l-3.19-8.35c-.81,3.06-2.1,5.57-3.12,8.35h6.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aa-6",
    "data-name": "aa",
    className: "cls-6-cookie-p2",
    d: "M978.3,413.18v14.94h-2.31v-14.94h-5.77v-1.9h13.85v1.9h-5.77"
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    id: "rect10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1-cookie-p2",
    d: "M662.29,946.5c0-3.31,2.69-6,6-6h330.26c3.31,0,6,2.69,6,6v100c0,3.31-2.69,6-6,6h-330.26c-3.31,0-6-2.69-6-6v-100Z"
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    id: "I"
  }, /*#__PURE__*/React.createElement("path", {
    id: "at-7",
    "data-name": "at",
    className: "cls-6-cookie-p2",
    d: "M764.19,987.96c-.68-1.9-2.38-3.06-4.96-3.06-4.01,0-5.91,2.72-5.91,6.72s1.97,6.86,6.04,6.86c2.92,0,4.21-1.63,5.3-3.53l1.83.95c-1.22,2.58-3.46,4.48-7.27,4.48-5.43,0-7.94-3.4-8.22-8.76-.41-7.06,6.72-10.39,12.7-7.54,1.29.61,2.1,1.77,2.65,3.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ai-18",
    "data-name": "ai",
    className: "cls-6-cookie-p2",
    d: "M774.18,986.95c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM774.11,998.76c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad-22",
    "data-name": "ad",
    className: "cls-6-cookie-p2",
    d: "M788.91,986.95c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aH",
    className: "cls-6-cookie-p2",
    d: "M801.4,984.23c-2.1-.61-2.85.68-2.58,2.99h2.58v1.56h-2.58v11.34h-2.1v-11.34h-1.83v-1.56h1.83c-.48-3.53,1.15-5.57,4.69-4.62v1.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah-16",
    "data-name": "ah",
    className: "cls-6-cookie-p2",
    d: "M802.97,984.43v-2.04h2.17v2.04h-2.17ZM802.97,1000.12v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ab-10",
    "data-name": "ab",
    className: "cls-6-cookie-p2",
    d: "M814.44,989.05c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "as-5",
    "data-name": "as",
    className: "cls-6-cookie-p2",
    d: "M829.04,988.64c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    id: "J"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aI",
    className: "cls-6-cookie-p2",
    d: "M851.58,1000.39c-5.57,0-8.22-3.26-8.49-8.76-.34-7.27,6.79-10.46,13.1-7.54,1.15.54,1.97,1.7,2.51,2.92l-2.17.61c-.88-1.7-2.51-2.72-5.16-2.72-4.14,0-5.98,2.65-5.98,6.72s1.97,6.79,6.18,6.86c2.38,0,4.21-.75,5.36-1.83v-3.06h-5.02v-1.9h7.13v5.84c-1.7,1.7-4.14,2.85-7.47,2.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ai-19",
    "data-name": "ai",
    className: "cls-6-cookie-p2",
    d: "M867.68,986.95c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM867.61,998.76c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    id: "K"
  }, /*#__PURE__*/React.createElement("path", {
    id: "af-13",
    "data-name": "af",
    className: "cls-6-cookie-p2",
    d: "M882.89,1000.12v-17.72h2.17v17.72h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah-17",
    "data-name": "ah",
    className: "cls-6-cookie-p2",
    d: "M888.25,984.43v-2.04h2.17v2.04h-2.17ZM888.25,1000.12v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "az-6",
    "data-name": "az",
    className: "cls-6-cookie-p2",
    d: "M899.32,1000.12h-2.58l-4.69-12.9h2.31l3.67,11.2,3.8-11.2h2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ak-27",
    "data-name": "ak",
    className: "cls-6-cookie-p2",
    d: "M911,986.95c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM914.53,992.45c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    id: "rect12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1-cookie-p2",
    d: "M662.29,1126.5c0-3.31,2.69-6,6-6h330.26c3.31,0,6,2.69,6,6v100c0,3.31-2.69,6-6,6h-330.26c-3.31,0-6-2.69-6-6v-100Z"
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    id: "L"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aJ",
    className: "cls-6-cookie-p2",
    d: "M734.32,1168.1c-.07,2.78-1.56,4.35-4.07,4.75l4.75,7.27h-2.58l-4.41-6.99h-5.23v6.99h-2.24v-16.84c5.98.2,13.92-1.43,13.78,4.82ZM722.77,1171.36c4.07-.14,9.3.88,9.3-3.19s-5.43-2.85-9.3-3.06v6.25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ak-28",
    "data-name": "ak",
    className: "cls-6-cookie-p2",
    d: "M742.87,1166.95c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM746.4,1172.45c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "an-9",
    "data-name": "an",
    className: "cls-6-cookie-p2",
    d: "M756.18,1168.64c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ai-20",
    "data-name": "ai",
    className: "cls-6-cookie-p2",
    d: "M768.68,1166.95c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM768.61,1178.76c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ab-11",
    "data-name": "ab",
    className: "cls-6-cookie-p2",
    d: "M783.21,1169.05c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "al-16",
    "data-name": "al",
    className: "cls-6-cookie-p2",
    d: "M789.32,1166.95c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM789.93,1168.58c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    id: "M"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ah-18",
    "data-name": "ah",
    className: "cls-6-cookie-p2",
    d: "M805.55,1164.43v-2.04h2.17v2.04h-2.17ZM805.55,1180.12v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad-23",
    "data-name": "ad",
    className: "cls-6-cookie-p2",
    d: "M817.22,1166.95c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    id: "N"
  }, /*#__PURE__*/React.createElement("path", {
    id: "an-10",
    "data-name": "an",
    className: "cls-6-cookie-p2",
    d: "M836.17,1168.64c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "au-5",
    "data-name": "au",
    className: "cls-6-cookie-p2",
    d: "M849.07,1168.64c-4.89,0-2.99,6.93-3.33,11.48h-2.17v-17.72h2.17l-.07,6.99c.81-1.43,1.9-2.44,4.14-2.44,6.04,0,3.6,7.88,4.07,13.17h-2.17v-8.22c.14-2.17-.54-3.33-2.65-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ac-27",
    "data-name": "ac",
    className: "cls-6-cookie-p2",
    d: "M865.03,1177.67c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM858.71,1176.52c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad-24",
    "data-name": "ad",
    className: "cls-6-cookie-p2",
    d: "M876.98,1166.95c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "av-5",
    "data-name": "av",
    className: "cls-6-cookie-p2",
    d: "M894.63,1167.22c-.68,8.49,2.78,19.9-7.47,17.72-1.56-.41-2.58-1.36-2.99-2.92l2.17-.34c1.02,3.19,6.79,2.17,6.04-1.9v-2.04c-.75,1.43-1.97,2.44-4.14,2.44-3.67,0-4.62-2.78-4.62-6.52s1.09-6.59,4.82-6.65c1.97-.07,3.26,1.09,4.01,2.38.07-.68,0-1.56.14-2.17h2.04ZM889,1178.62c2.44,0,3.4-2.17,3.4-4.96s-.95-5.09-3.4-5.09c-2.65,0-3.12,2.31-3.12,5.09s.41,4.96,3.12,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ak-29",
    "data-name": "ak",
    className: "cls-6-cookie-p2",
    d: "M902.98,1166.95c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM906.51,1172.45c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    id: "O"
  }, /*#__PURE__*/React.createElement("path", {
    id: "af-14",
    "data-name": "af",
    className: "cls-6-cookie-p2",
    d: "M918.19,1180.12v-17.72h2.17v17.72h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ai-21",
    "data-name": "ai",
    className: "cls-6-cookie-p2",
    d: "M928.72,1166.95c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM928.65,1178.76c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "av-6",
    "data-name": "av",
    className: "cls-6-cookie-p2",
    d: "M947.53,1167.22c-.68,8.49,2.78,19.9-7.47,17.72-1.56-.41-2.58-1.36-2.99-2.92l2.17-.34c1.02,3.19,6.79,2.17,6.04-1.9v-2.04c-.75,1.43-1.97,2.44-4.14,2.44-3.67,0-4.62-2.78-4.62-6.52s1.09-6.59,4.82-6.65c1.97-.07,3.26,1.09,4.01,2.38.07-.68,0-1.56.14-2.17h2.04ZM941.89,1178.62c2.44,0,3.4-2.17,3.4-4.96s-.95-5.09-3.4-5.09c-2.65,0-3.12,2.31-3.12,5.09s.41,4.96,3.12,4.96"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4-cookie-p2",
    d: "M833.43,1053.5v50.12"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3-cookie-p2",
    d: "M833.93,1053.5h-1v-.5h1v.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2-cookie-p2",
    d: "M833.43,1118.38l-4.65-14.26h9.28l-4.63,14.26Z"
  })), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    id: "diamond1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11-cookie-p2",
    d: "M838.23,643.6c3.17-1.9,7.13-1.9,10.3,0l160.83,96.62c1.71,1.02,2.26,3.23,1.24,4.94-.3.51-.73.94-1.24,1.24l-160.84,96.63c-3.17,1.9-7.13,1.9-10.3,0l-160.83-96.63c-1.71-1.02-2.26-3.23-1.24-4.94.3-.51.73-.94,1.24-1.24l160.84-96.62Z"
  }))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    id: "Q"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aK",
    className: "cls-5-cookie-p2",
    d: "M776.27,716.34c-.68-1.9-2.38-3.06-4.96-3.06-4.01,0-5.91,2.72-5.91,6.72s1.97,6.86,6.04,6.86c2.92,0,4.21-1.63,5.3-3.53l1.83.95c-1.22,2.58-3.46,4.48-7.27,4.48-5.43,0-7.94-3.4-8.22-8.76-.41-7.06,6.72-10.39,12.7-7.54,1.29.61,2.1,1.77,2.65,3.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aL",
    className: "cls-5-cookie-p2",
    d: "M786.66,717.02c-4.89,0-2.99,6.93-3.33,11.48h-2.17v-17.72h2.17l-.07,6.99c.81-1.43,1.9-2.44,4.14-2.44,6.04,0,3.6,7.88,4.07,13.17h-2.17v-8.22c.14-2.17-.54-3.33-2.65-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aM",
    className: "cls-5-cookie-p2",
    d: "M802.61,726.05c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM796.3,724.89c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aN",
    className: "cls-5-cookie-p2",
    d: "M814.56,715.32c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aO",
    className: "cls-5-cookie-p2",
    d: "M832.22,715.59c-.68,8.49,2.78,19.9-7.47,17.72-1.56-.41-2.58-1.36-2.99-2.92l2.17-.34c1.02,3.19,6.79,2.17,6.04-1.9v-2.04c-.75,1.43-1.97,2.44-4.14,2.44-3.67,0-4.62-2.78-4.62-6.52s1.09-6.59,4.82-6.65c1.97-.07,3.26,1.09,4.01,2.38.07-.68,0-1.56.14-2.17h2.04ZM826.58,727c2.44,0,3.4-2.17,3.4-4.96s-.95-5.09-3.4-5.09c-2.65,0-3.12,2.31-3.12,5.09s.41,4.96,3.12,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aP",
    className: "cls-5-cookie-p2",
    d: "M840.57,715.32c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM844.1,720.82c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aQ",
    className: "cls-5-cookie-p2",
    d: "M856.53,718.78c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    id: "R"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aM-2",
    "data-name": "aM",
    className: "cls-5-cookie-p2",
    d: "M875.95,726.05c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM869.63,724.89c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aR",
    className: "cls-5-cookie-p2",
    d: "M886.81,712.6c-2.1-.61-2.85.68-2.58,2.99h2.58v1.56h-2.58v11.34h-2.1v-11.34h-1.83v-1.56h1.83c-.48-3.53,1.15-5.57,4.69-4.62v1.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aR-2",
    "data-name": "aR",
    className: "cls-5-cookie-p2",
    d: "M893.12,712.6c-2.1-.61-2.85.68-2.58,2.99h2.58v1.56h-2.58v11.34h-2.1v-11.34h-1.83v-1.56h1.83c-.48-3.53,1.15-5.57,4.69-4.62v1.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aP-2",
    "data-name": "aP",
    className: "cls-5-cookie-p2",
    d: "M899.85,715.32c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM903.38,720.82c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aS",
    className: "cls-5-cookie-p2",
    d: "M913.16,717.02c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aT",
    className: "cls-5-cookie-p2",
    d: "M922.86,725.3c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    id: "S"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aU",
    className: "cls-5-cookie-p2",
    d: "M763.61,769.56h-2.31l-6.86-16.84h2.38l5.64,14.8,5.64-14.8h2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aP-3",
    "data-name": "aP",
    className: "cls-5-cookie-p2",
    d: "M776.04,756.39c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM779.57,761.89c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aP-4",
    "data-name": "aP",
    className: "cls-5-cookie-p2",
    d: "M789.62,756.39c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM793.15,761.89c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aV",
    className: "cls-5-cookie-p2",
    d: "M803.74,769.56h-2.58l-4.69-12.9h2.31l3.67,11.2,3.8-11.2h2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aM-3",
    "data-name": "aM",
    className: "cls-5-cookie-p2",
    d: "M818.21,767.12c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM811.89,765.96c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    id: "T"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aW",
    className: "cls-5-cookie-p2",
    d: "M839.39,752.72c-.54,6.79,2.38,17.11-4.96,17.11-2.99-.07-4.55-1.7-5.02-4.48l2.17-.34c.27,1.7,1.09,2.85,2.92,2.92,1.83,0,2.65-1.36,2.65-3.33v-9.98h-3.26v-1.9h5.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aX",
    className: "cls-5-cookie-p2",
    d: "M848.01,756.39c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM847.95,768.2c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aY",
    className: "cls-5-cookie-p2",
    d: "M862.61,756.39c3.6,0,4.69,2.65,4.75,6.65,0,4.48-1.56,6.79-4.75,6.79-2.1-.07-3.33-.75-4.01-2.31l-.14,2.04h-2.1l.07-17.72h2.17v6.86c.68-1.56,1.9-2.31,4.01-2.31ZM862.07,768.2c2.72,0,3.06-2.31,3.06-5.09s-.34-5.09-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    id: "U"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aZ",
    className: "cls-5-cookie-p2",
    d: "M886.04,760.67c2.38.34,4.14,1.56,4.14,4.14,0,5.91-7.2,4.62-12.97,4.75v-16.84c5.16.2,12.02-1.15,12.02,4.07,0,2.24-1.29,3.4-3.19,3.87ZM879.45,759.92c3.4-.07,7.47.61,7.47-2.85,0-3.19-4.28-2.44-7.47-2.51v5.36ZM879.45,767.73c3.73-.14,8.42.95,8.42-3.06s-4.75-2.85-8.42-2.99v6.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aM-4",
    "data-name": "aM",
    className: "cls-5-cookie-p2",
    d: "M901.04,767.12c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM894.73,765.96c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aO-2",
    "data-name": "aO",
    className: "cls-5-cookie-p2",
    d: "M917.07,756.66c-.68,8.49,2.78,19.9-7.47,17.72-1.56-.41-2.58-1.36-2.99-2.92l2.17-.34c1.02,3.19,6.79,2.17,6.04-1.9v-2.04c-.75,1.43-1.97,2.44-4.14,2.44-3.67,0-4.62-2.78-4.62-6.52s1.09-6.59,4.82-6.65c1.97-.07,3.26,1.09,4.01,2.38.07-.68,0-1.56.14-2.17h2.04ZM911.43,768.07c2.44,0,3.4-2.17,3.4-4.96s-.95-5.09-3.4-5.09c-2.65,0-3.12,2.31-3.12,5.09s.41,4.96,3.12,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ba",
    className: "cls-5-cookie-p2",
    d: "M925.62,752.52c5.7,0,7.54,6.59,3.06,9.03-1.29.68-2.51,1.63-2.65,3.53h-2.1c0-4.28,5.23-3.73,5.23-7.74,0-2.04-1.43-2.85-3.53-2.92-2.17,0-3.6,1.15-3.8,3.12l-2.17-.14c.48-3.06,2.31-4.89,5.98-4.89ZM923.86,769.56v-2.38h2.31v2.38h-2.31"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12-cookie-p2",
    d: "M843.88,921.05h-1v-23.5h1v23.5ZM843.88,868.22h-1v-22.76h1v22.76Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7-cookie-p2",
    d: "M843.38,844.96l.5-.03v.54h-1v-.54l.5.03Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12-cookie-p2",
    d: "M843.38,844.93l.53-.03v.6h-1.05v-.6l.52.03ZM842.91,845.43h.95v-.47l-.48.02-.47-.03v.48Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7-cookie-p2",
    d: "M843.38,935.82l-4.63-14.27h9.27l-4.64,14.27Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12-cookie-p2",
    d: "M843.38,937.44l-5.32-16.4h10.65l-5.33,16.4ZM839.44,922.04l3.95,12.16,3.95-12.15h-7.9Z"
  })), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    id: "V"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bb",
    className: "cls-9",
    d: "M837.99,887.78l-8.96-14.33.07,14.33h-1.97v-16.84h2.65l9.03,14.46-.14-14.46h2.1v16.84h-2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bc",
    className: "cls-9",
    d: "M852.18,870.73c5.5,0,8.35,3.12,8.35,8.56s-2.99,8.76-8.35,8.76-8.35-3.33-8.35-8.76,2.85-8.56,8.35-8.56ZM852.18,886.15c4.28,0,6.04-2.78,6.04-6.86s-1.97-6.72-6.04-6.72-6.04,2.65-6.04,6.72,1.9,6.79,6.04,6.86"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12-cookie-p2",
    d: "M601.4,743.8h-86.46l-.88.08-.83.2-.8.33-.75.46-.65.56-.56.66-.45.73-.34.8-.2.85-.07.88v374.3h-1v-374.34l.06-1,.24-1,.4-.94.52-.87.67-.8.76-.65.87-.53.95-.4,1-.23,1-.1h86.5l.02,1.01ZM674.65,743.8h-24.37v-1h24.37v1Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7-cookie-p2",
    d: "M675.15,743.3l.05.5h-.57v-1h.57l-.05.5Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12-cookie-p2",
    d: "M675.17,743.3l.06.53h-.62v-1.05h.62l-.06.52ZM674.67,742.83v.95h.5l-.05-.47.04-.47h-.49Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7-cookie-p2",
    d: "M508.93,1138.38l-4.65-14.26h9.27l-4.62,14.26Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12-cookie-p2",
    d: "M508.93,1140l-5.34-16.38h10.65l-5.31,16.38ZM504.97,1124.62l3.94,12.14,3.95-12.14h-7.89Z"
  })), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    id: "W"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bd",
    className: "cls-10-cookie-p2",
    d: "M610.7,741.21v6.99h-2.31v-6.99l-6.45-9.85h2.51l5.09,8.01,5.09-8.01h2.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "be",
    className: "cls-10-cookie-p2",
    d: "M619.73,748.2v-16.84h12.7v1.9h-10.46v5.36h9.78v1.83h-9.78v5.91h11v1.83h-13.24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bf",
    className: "cls-10-cookie-p2",
    d: "M646.55,735.37c-.34-3.26-8.35-3.67-8.42.14.95,5.09,10.73.95,11.07,8.08.2,5.3-8.22,5.91-11.88,3.73-1.15-.68-1.9-1.77-2.24-3.12l2.24-.48c.34,3.8,9.57,4.28,9.57-.07,0-5.3-10.52-.95-11-8.01-.34-5.57,9.85-5.7,12.15-2.31.34.48.54,1.09.75,1.7"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14-cookie-p2",
    d: "M343.26,1181.3h55.95M343.27,1181.3h-.5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13-cookie-p2",
    d: "M413.98,1181.3l-14.27,4.62v-9.27l14.27,4.65Z"
  })), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    id: "rect13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15-cookie-p2",
    d: "M416.09,1146.5c0-3.31,2.69-6,6-6h173.64c3.31,0,6,2.69,6,6v69.57c0,3.31-2.69,6-6,6h-173.64c-3.31,0-6-2.69-6-6v-69.57Z"
  }))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "X"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bg",
    className: "cls-8-cookie-p2",
    d: "M451.72,1173.72c-.34-3.26-8.35-3.67-8.42.14.95,5.09,10.73.95,11.07,8.08.2,5.3-8.22,5.91-11.88,3.73-1.15-.68-1.9-1.77-2.24-3.12l2.24-.48c.34,3.8,9.57,4.28,9.57-.07,0-5.3-10.52-.95-11-8.01-.34-5.57,9.85-5.7,12.15-2.31.34.48.54,1.09.75,1.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bh",
    className: "cls-8-cookie-p2",
    d: "M462.24,1173.38c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM465.78,1178.88c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bh-2",
    "data-name": "bh",
    className: "cls-8-cookie-p2",
    d: "M475.82,1173.38c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM479.36,1178.88c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Y"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bi",
    className: "cls-8-cookie-p2",
    d: "M491.44,1169.72c5.91.07,12.97-1.02,12.97,5.09,0,5.3-5.23,5.43-10.73,5.16v6.59h-2.24v-16.84ZM493.68,1178.2c3.87,0,8.42.75,8.42-3.4s-4.62-3.19-8.42-3.26v6.65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bj",
    className: "cls-8-cookie-p2",
    d: "M512.9,1175.08c-4.89,0-2.99,6.93-3.33,11.48h-2.17v-17.72h2.17l-.07,6.99c.81-1.43,1.9-2.44,4.14-2.44,6.04,0,3.6,7.88,4.07,13.17h-2.17v-8.22c.14-2.17-.54-3.33-2.65-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bk",
    className: "cls-8-cookie-p2",
    d: "M528.85,1184.11c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM522.54,1182.96c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bl",
    className: "cls-8-cookie-p2",
    d: "M542.03,1176.85c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bh-3",
    "data-name": "bh",
    className: "cls-8-cookie-p2",
    d: "M551.87,1173.38c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM555.4,1178.88c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Z"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bm",
    className: "cls-8-cookie-p2",
    d: "M574.01,1177.93c2.24.41,3.94,1.36,3.94,4.01,0,5.98-9.44,6.25-11.14,1.97-.2-.54-.34-1.09-.41-1.7l2.17-.2c.41,1.83,1.43,2.99,3.67,2.99s3.53-1.02,3.53-3.12c0-2.58-2.44-3.12-5.36-2.92v-1.9c2.65.07,4.89-.27,4.89-2.85,0-1.83-1.15-2.92-3.12-2.92s-3.19,1.02-3.33,2.78l-2.17-.2c.41-2.85,2.38-4.28,5.5-4.35,3.26-.07,5.36,1.43,5.36,4.41,0,2.44-1.43,3.53-3.53,4.01"
  })))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4-cookie-p2",
    d: "M171.63,113.5v50.12"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3-cookie-p2",
    d: "M172.13,113.5h-1v-.5h1v.5Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2-cookie-p2",
    d: "M171.63,178.38l-4.64-14.26h9.28l-4.64,14.26Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4-cookie-p2",
    d: "M171.63,293.5v58.12"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3-cookie-p2",
    d: "M172.13,293.5h-1v-.5h1v.5Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2-cookie-p2",
    d: "M171.63,366.38l-4.64-14.26h9.28l-4.64,14.26Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4-cookie-p2",
    d: "M177.46,481.5v58.12"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3-cookie-p2",
    d: "M177.96,481.5h-1v-.5h1v.5Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2-cookie-p2",
    d: "M177.46,554.38l-4.63-14.26h9.27l-4.64,14.26Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4-cookie-p2",
    d: "M171.63,669.5v58.12"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3-cookie-p2",
    d: "M172.13,669.5h-1v-.5h1v.5Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2-cookie-p2",
    d: "M171.63,742.38l-4.64-14.26h9.28l-4.64,14.26Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4-cookie-p2",
    d: "M167.58,857.5v66.12"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3-cookie-p2",
    d: "M168.08,857.5h-1v-.5h1v.5Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2-cookie-p2",
    d: "M167.58,938.38l-4.63-14.26h9.27l-4.64,14.26Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4-cookie-p2",
    d: "M170.77,1053.5v50.12"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3-cookie-p2",
    d: "M171.27,1053.5h-1v-.5h1v.5Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2-cookie-p2",
    d: "M170.77,1118.38l-4.64-14.26h9.27l-4.63,14.26Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4-cookie-p2",
    d: "M841.35,113.5v50.12"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3-cookie-p2",
    d: "M841.85,113.5h-1v-.5h1v.5Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2-cookie-p2",
    d: "M841.35,178.38l-4.64-14.26h9.27l-4.63,14.26Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4-cookie-p2",
    d: "M841.35,293.5v36.9c0,.06-.04.1-.1.1-.05-.01-.11.02-.12.08,0,0,0,.01,0,.02v21.02"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3-cookie-p2",
    d: "M841.85,293.5h-1v-.5h1v.5Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2-cookie-p2",
    d: "M841.13,366.38l-4.64-14.26h9.28l-4.64,14.26Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4-cookie-p2",
    d: "M843.38,481.5v143.78"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3-cookie-p2",
    d: "M843.88,481.5h-1v-.5h1v.5Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2-cookie-p2",
    d: "M843.38,640.04l-4.63-14.26h9.27l-4.64,14.26Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCookiePhase2);
export default __webpack_public_path__ + "static/media/Cookie_Phase_2.4ffd433bffa11cf0e84880dc866e32c3.svg";
export { ForwardRef as ReactComponent };